import axiosClient from "./axiosClient";
import { IHoursUploadDTO } from "@interfaces/IHoursUploadDTO"
import { ISendHoursEditDTO } from "@interfaces/ISendHoursEditDTO";

export function generateTemplate(data: Partial<IHoursUploadDTO>) {
  return axiosClient.post<{ status: string; data: { plant_id: string, start_date: string; end_date: string; } }>(
    "/template_new/hours",
    data,
    { responseType: "blob" }
  );
}

export function getEditHours(data: Partial<IHoursUploadDTO>) {
  return axiosClient.post(
    "/admin/hours_new/edit",
    data
  );
}

export function editHours(data: Partial<ISendHoursEditDTO>) {
  return axiosClient.post(
    "/hours_new/edit",
    data
  );
}
